const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class ServiceCategoryService {
  // Obtener todas las categorías
  async getCategories(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const response = await fetch(`${API_BASE_URL}/api/service-categories?${queryParams}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener las categorías');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getCategories:', error);
      throw error;
    }
  }

  // Obtener categorías activas
  async getActiveCategories() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/service-categories/active`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener las categorías activas');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getActiveCategories:', error);
      throw error;
    }
  }

  // Obtener una categoría por ID
  async getCategoryById(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/service-categories/${id}`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener la categoría');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getCategoryById:', error);
      throw error;
    }
  }

  // Crear nueva categoría
  async createCategory(categoryData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/service-categories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(categoryData),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al crear la categoría');
      }
      
      return data;
    } catch (error) {
      console.error('Error en createCategory:', error);
      throw error;
    }
  }

  // Actualizar categoría
  async updateCategory(id, categoryData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/service-categories/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(categoryData),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar la categoría');
      }
      
      return data;
    } catch (error) {
      console.error('Error en updateCategory:', error);
      throw error;
    }
  }

  // Eliminar categoría
  async deleteCategory(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/service-categories/${id}`, {
        method: 'DELETE',
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar la categoría');
      }
      
      return data;
    } catch (error) {
      console.error('Error en deleteCategory:', error);
      throw error;
    }
  }

  // Restaurar categoría
  async restoreCategory(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/service-categories/${id}/restore`, {
        method: 'PATCH',
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al restaurar la categoría');
      }
      
      return data;
    } catch (error) {
      console.error('Error en restoreCategory:', error);
      throw error;
    }
  }

  // Obtener estadísticas de categorías
  async getCategoryStats() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/service-categories/stats`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener las estadísticas');
      }
      
      return data;
    } catch (error) {
      console.error('Error en getCategoryStats:', error);
      throw error;
    }
  }
}

export default new ServiceCategoryService();
